import React from 'react';
import { oohData } from '../utils/oohData';
import { ZapIcon, CheckCircleIcon, AlertTriangleIcon } from 'lucide-react';
export const ExecutiveSummary: React.FC = () => {
  const {
    headlineVerdict,
    topStrengths,
    topImprovements
  } = oohData;
  return <div className="bg-white rounded-xl shadow-sm border-t-4 border-t-[#1E90FF] p-6" data-id="element-149">
      {/* Headline verdict */}
      <div className="flex items-start space-x-3 mb-8" data-id="element-150">
        <div className="p-2 bg-[#1E90FF]/10 rounded-lg flex-shrink-0" data-id="element-151">
          <ZapIcon className="h-5 w-5 text-[#1E90FF]" data-id="element-152" />
        </div>
        <div data-id="element-153">
          <p className="text-xs font-semibold text-[#1E90FF] uppercase tracking-wider mb-1" data-id="element-154">
            Executive Summary
          </p>
          <h2 className="text-xl md:text-2xl font-semibold text-gray-900 leading-tight" data-id="element-155">
            {headlineVerdict}
          </h2>
        </div>
      </div>

      {/* Working vs Fixes — each item is self-explanatory, no hover needed */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-156">
        {/* What's working */}
        <div className="bg-green-50/50 border border-green-100 rounded-xl p-5" data-id="element-157">
          <div className="flex items-center space-x-2 mb-4" data-id="element-158">
            <CheckCircleIcon className="export-icon-down h-5 w-5 text-green-600" data-id="element-159" />
            <h3 className="text-sm font-semibold text-green-800 uppercase tracking-wide" data-id="element-160">
              What’s working
            </h3>
          </div>
          <ul className="space-y-3" data-id="element-161">
            {topStrengths.map((strength, idx) => <li key={idx} className="flex items-start space-x-3" data-id="element-162">
                <span className="export-dot-down mt-1.5 w-1.5 h-1.5 rounded-full bg-green-500 flex-shrink-0" data-id="element-163" />
                <p className="text-sm text-gray-700 leading-relaxed" data-id="element-164">
                  <span className="font-semibold text-gray-900" data-id="element-165">
                    {strength.name}.
                  </span>{' '}
                  {strength.description}
                </p>
              </li>)}
          </ul>
        </div>

        {/* Priority fixes */}
        <div className="bg-amber-50/60 border border-amber-200 rounded-xl p-5" data-id="element-166">
          <div className="flex items-center space-x-2 mb-4" data-id="element-167">
            <AlertTriangleIcon className="export-icon-down h-5 w-5 text-amber-600" data-id="element-168" />
            <h3 className="text-sm font-semibold text-amber-800 uppercase tracking-wide" data-id="element-169">
              Priority fixes
            </h3>
          </div>
          <ol className="space-y-3" data-id="element-170">
            {topImprovements.map((improvement, idx) => <li key={idx} className="flex items-start space-x-3" data-id="element-171">
                <span className="mt-0.5 flex-shrink-0 flex items-center justify-center w-5 h-5 rounded-full bg-amber-500 text-white text-[11px] font-bold leading-none" data-id="element-172">
                  <span className="export-text-up" data-id="element-173">{idx + 1}</span>
                </span>
                <p className="text-sm text-gray-700 leading-relaxed" data-id="element-174">
                  <span className="font-semibold text-gray-900" data-id="element-175">
                    {improvement.name}.
                  </span>{' '}
                  {improvement.description}
                </p>
              </li>)}
          </ol>
        </div>
      </div>
    </div>;
};